var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtractbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1800,
    height: 1203,
    viewBox: "0 0 1800 1203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71948 43.6808C0 60.7937 0 83.1958 0 128V409.037C0 467.322 0 496.465 12.1582 515.92C22.8064 532.959 39.4763 545.367 58.8541 550.678C80.98 556.742 108.897 548.379 164.731 531.653L454 445C494 436 521.206 445 538.319 453.719C553.372 461.389 565.611 473.628 573.281 488.681C582 505.794 582 528.196 582 573V1075C582 1119.8 582 1142.21 590.719 1159.32C598.389 1174.37 610.628 1186.61 625.681 1194.28C642.794 1203 665.196 1203 710 1203H1672C1716.8 1203 1739.21 1203 1756.32 1194.28C1771.37 1186.61 1783.61 1174.37 1791.28 1159.32C1800 1142.21 1800 1119.8 1800 1075V128C1800 83.1958 1800 60.7937 1791.28 43.6808C1783.61 28.6278 1771.37 16.3893 1756.32 8.71948C1739.21 0 1716.8 0 1672 0H128C83.1958 0 60.7937 0 43.6808 8.71948C28.6278 16.3893 16.3893 28.6278 8.71948 43.6808Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractbg);
export default __webpack_public_path__ + "static/media/subtractbg.b0f2d1a5bbf8bb78b445209975f8e127.svg";
export { ForwardRef as ReactComponent };